import Coach from '../../../../Model/Coach';

export const loadAudienceConfig = async (coachId) => {
  const coach = await Coach.getCoachById(coachId);

  return {
    leadDisqualificationConfig: coach?.leadDisqualificationConfig,
    isEnrolledInISProgram: coach?.isEnrolledInISProgram,
  };
};
